import router from "../../../router";
import RoutesPaths from "../../../router/router-structure/routes-paths";
import store from "../../../store/index";
import { showBackbeat } from "../../../services/backbeat/route-page";
import { getNewByName } from "../../../utils/news/news-utils";
import { saveNewness, validateShowNewness } from "../../../services/newness/newness-new.js";
import { getLinkByCode } from "../../../utils/links-external/links-external-utils";

const removeNewIfLastLevel = (featureName) => {
  const checkValidateShowNewness = validateShowNewness();
    if (checkValidateShowNewness && checkValidateShowNewness == true) {
    const currentNew = getNewByName(featureName);
    if (currentNew && currentNew?.lastLevel) {
      saveNewness(currentNew?.idConfigurationNewness);
      store.dispatch(
        "removeNewness",
        currentNew?.idConfigurationNewness
      );
    }
  }
}
export const dropdownHome = () => {
  return [];
}

export const dropdownInstitucional = () => {
  return [
    {
      label: "Atas e documentos",
      featureName: "INSTITUCIONAL_DOCUMENT_ATAS_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.documentsAtasPage.documentsAtas(),
          replace: true,
        });
      },
    },
    {
      label: "Conexão Cooperado",
      featureName: "HOME_CONNECTION_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.connection.rootName(),
          replace: true,
        });
      },
    },
    {
      label: "Nossa história",
      featureName: "INSTITUCIONAL_OUR_STORY_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        window.open(getLinkByCode("OUR_STORY"), "_blank");
      },
    },
    {
      label: "Organograma",
      featureName: "INSTITUCIONAL_ORGANIZATIONAL_CHART",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.institutionalPage.rootName(),
          query: { openLink: "true" },
          replace: true,
        });
      },
      showMobile: false,
    },
    {
      label: "Painel econômico",
      featureName: "INSTITUCIONAL_ECONOMIC_DASHBOARD_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({ path: RoutesPaths.institutionalPage.panelEconomic(), replace: true });
      },
    },
    {
      label: "Reconhecimento",
      featureName: "INSTITUCIONAL_RECOGNITIONS_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        window.open(getLinkByCode("COLLECTIONS"), "_blank");
      },
    },
    {
      label: "Rol de coberturas e DUTs",
      featureName: "INSTITUCIONAL_ANT_DUTS_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        window.open(getLinkByCode("ANT_DUTS"), "_blank");
      },
    },
    {
      label: "Tecnologia em Saúde",
      featureName: "INSTITUCIONAL_NEW_TECNOLOGY_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        window.open(getLinkByCode("NEW_TECNOLOGY"), "_blank");
      },
    },
    {
      label: "Transparência",
      featureName: "INSTITUCIONAL_TRANSPARENCY_AND_COMMITMENT_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        window.open(getLinkByCode("TRANSPARENCY_AND_COMMITMENT"), "_blank");
      },
    },
  ];
};

export const dropdownCadastro = () => {
  return [
    {
      label: "Dados Pessoais",
      featureName: "REGISTER_PERSONAL_INFORMATION_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.register.personalInformation(),
          replace: true,
        });
      },
    },
    {
      label: "Especialidades médicas",
      featureName: "REGISTER_MEDICAL_SPECIALITIES_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.register.medicalSpecialities(),
          replace: true,
        });
      },
    },
    {
      label: "Impostos e alvarás",
      featureName: "REGISTER_TAX_LICENSE_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({ path: RoutesPaths.register.taxLicense(), replace: true });
      },
    },
    {
      label: "Locais de atendimento",
      featureName: "REGISTER_ATTENDENCE_PLACE_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.register.attendencePlace(),
          replace: true,
        });
      },
    },
    {
      label: "Meios de pagamento",
      featureName: "REGISTER_PAYMENT_OPTIONS_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.register.paymentOptions(),
          replace: true,
        });
      },
    },
    {
      label: "Participação em assembleias",
      featureName: "ASSEMBLY_PARTICIPATION_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({ path: RoutesPaths.contentManagement.assemblyParticipation(), replace: true });
      },
    },
  ];
};

export const dropdownDeclaracoes = () => {
  return [
    {
      label: "Declaração do médico cooperado",
      featureName: "DECLARATION_COOPERATIVE_DECLARATION_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push(RoutesPaths.declarations.cooperativeDeclaration());
      },
    },
    {
      label: "Histórico de retenção de INSS",
      featureName: "DECLARATION_INSS_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push(RoutesPaths.declarations.inss());
      },
    },
    {
      label: "Histórico de retenção de ISS",
      featureName: "DECLARATION_ISS_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push(RoutesPaths.declarations.iss());
      },
    },
    {
      label: "LCTA / PPP",
      featureName: "DECLARATION_LTCAT_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push(RoutesPaths.declarations.ltcatpp());
      },
    },
    {
      label: "Solicitar outras declarações",
      featureName: "DECLARATION_OTHERS_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push(RoutesPaths.declarations.others());
      },
    },
  ];
};

export const dropdownConsultorioVirtual = () => {
  return [
     {
      label: "APS Unimed",
      featureName: "VIRTUAL_PEP_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        window.open(getLinkByCode("PEP"), "_blank");
      },
    },
    {
      label: "Hub de agendamento",
      featureName: "VIRTUAL_HUB_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        window.open(getLinkByCode("HUB"), "_blank");
      },
    },
    {
      label: "RES - Registro eletrônico de saúde",
      featureName: "VIRTUAL_RES_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        window.open(getLinkByCode("RES_ELECTRONIC_HEALTH_RECORD"), "_blank");
      },
    },
    {
      label: "SGU-CARD",
      featureName: "VIRTUAL_SGU_CARD_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        window.open(getLinkByCode("SGU_CARD"), "_blank");
      },
    },
    {
      label: "Telemedicina",
      featureName: "VIRTUAL_MEDICINE_MENU",
      isDisabled: () => {  return store.getters.isAdmin }, 
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.virtualOffice.rootName(),
          query: { openLink: "true" },
          replace: true,
        });
      },
    },
  ];
};

export const dropdownBeneficios = () => {
  return [
    {
      label: "Afastamento",
      featureName: "BENEFIT_ABSENCE_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.benefit.absence(),
          replace: true,
        });
      },
    },
    {
      label: "Auxílio funeral",
      featureName: "BENEFIT_FUNERAL_ASSISTANCE_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.benefit.funeralAssistance(),
          replace: true,
        });
      },
    },
    {
      label: "Auxílio temporário",
      featureName: "BENEFIT_TEMPORARY_ASSISTANCE_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.benefit.temporaryAssistance(),
          replace: true,
        });
      },
    },
    {
      label: "Benemérito",
      featureName: "BENEFIT_BENEFACTOR_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.benefit.benefactor(),
          replace: true,
        });
      },
    },
    {
      label: "Meu Clube Unimed",
      featureName: "BENEFIT_CLUB_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        window.open(getLinkByCode("CLUB"), "_blank");
      },
    },
    {
      label: "Plano de saúde",
      featureName: "BENEFIT_HEALTH_PLAN_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.benefit.healthPlan(),
          replace: true,
        });
      },
    },
  ];
};

export const dropdownFinanceiro = () => {
  return [
    {
      label: "Analítica",
      featureName: "FINANCIAL_ANALYTICS_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.financial.analytics(),
          replace: true,
        });
      },
    },
    // {
    //   label: "Gestão de Produção", 
    //   featureName: "FINANCIAL_PRODUCTION_MANAGEMENT_MENU",
    //   action: function () {
    //     removeNewIfLastLevel(this.featureName)
    //     router.push({
    //       path: RoutesPaths.financial.productionManagement(),
    //       replace: true,
    //     });
    //   },
    // },
    {
      label: "Backbeat",
      featureName: "FINANCIAL_BACKBEAT_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        showBackbeat();
      },
    },
    {
      label: "Cota capital",
      featureName: "FINANCIAL_QUOTA_STATEMENT_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.financial.quotaStatement(),
          replace: true,
        });
      },
    },
    {
      label: "Fundo de sustentabilidade",
      featureName: "FINANCIAL_SUSTAINABILITY_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.financial.sustainabilityFund(),
          replace: true,
        });
      },
    },
    {
      label: "Histórico de notas fiscais",
      featureName: "FINANCIAL_INCOME_HISTORY_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.financial.incomeHistory(),
          replace: true,
        });
      },
    },
    {
      label: "Informe de rendimento",
      featureName: "FINANCIAL_REPORT_HISTORY_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.financial.reportIncome(),
          replace: true,
        });
      },
    },
    {
      label: "Recurso de glosas",
      featureName: "FINANCIAL_REVIEW_GLOSSARY_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
         router.push({
          path: RoutesPaths.financial.reviewGlosses(),
          replace: true,
        });
      },
    },
    {
      label: "Relatório de glosas Voxis",
      featureName: "FINANCIAL_REPORT_VOXIS_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.financial.reportVoxis(),
          replace: true,
        });
      },
    },
    {
      label: "Reembolso de Anuidade",
      featureName: "ANNUITY_REFUND",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.financial.annuityRefund(),
          replace: true,
        });
      },
    },
  ];
};

export const dropdownContentTrainingManagement = () => {
  return [
    {
      label: "Gestão de treinamentos",
      featureName: "CONTENT_MANAGEMENT_TRAINING_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.trainingManagement.rootName(),
          replace: true,
        });
      },
    },
    {
      label: "Gestão de certificados",
      featureName: "CONTENT_MANAGEMENT_CERTIFICATION_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.certificationManagement.rootName(),
          replace: true,
        });
      },
    },
    {
      label: "Gestão de vínculos",
      featureName: "CONTENT_MANAGEMENT_LINK_CERTIFICATION_TRAINING_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.linkCertificationTrainingManagement.rootName(),
          replace: true,
        });
      },
    },
  ];
};

export const dropdownContentReportManagement = () => {
  return [
    {
      label: "Visualizações do portal",
      featureName: "CONTENT_MANAGEMENT_REPORTS_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.reports.rootName(),
          replace: true,
        });
      },
    },
    {
      label: "Atualização Guia Médico",
      featureName: "CONTENT_MANAGEMENT_MEDICAL_GUIDE_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.medicalGuideManagement.rootName(),
          replace: true,
        });
      },
    },
    {
      label: "Contatos de referencias do Cooperado",
      featureName: "CONTACT_EMERGENCY_REPORT_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.contactEmergencyReport.rootName(),
          replace: true,
        });
      },
    },
  ];
};

export const dropdownContentManagement = () => {
  return [
    {
      label: "Gerenciamento de arquivos",
      featureName: "CONTENT_MANAGEMENT_FILE_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.fileManagement.rootName(),
          replace: true,
        });
      },
    },
    {
      label: "Participação Assembleia",
      featureName: "CONTENT_MANAGEMENT_ASSEMBLY_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.contentManagement.assemblyManagement(),
          replace: true,
        });
      },
    },
    {
      visible: false,
      label: "Gestão de notificações",
      featureName: "CONTENT_MANAGEMENT_NOTIFICATION_MENU",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: "",
          replace: true,
        });
      },
    },
    {
      label: "Gerenciamento de Links externos",
      featureName: "CONTENT_EXTERNAL_LINK_MANAGEMENT",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.externalLinkManagement.form(),
          replace: true,
        });
      },
    },
    {
      label: "Gestão de comunicados",
      featureName: "CONTENT_COMMUNICATION_MANAGEMENT",
      action: function () {
        removeNewIfLastLevel(this.featureName)
        router.push({
          path: RoutesPaths.communicationManagement.rootName(),
          replace: true,
        });
      },
    },
  ];
};

export const dropdownViewsReport = () => {
  return [];
};

